<template>
  <div class="tabs-view">
    <a-tabs :tab-position="'top'"
            :active-key="routePath"
            type="editable-card"
            @change="onChange"
            @edit="onEdit"
            @tab-scroll="callback">
      <a-tab-pane v-for="pane in tabsList"
                  :key="pane.linkTo || pane.key || '/'"
                  :tab="pane.name"
                  :closable="pane.affix != undefined ? pane.affix !== true : true"></a-tab-pane>
    </a-tabs>
  </div>
</template>
<script lang="ts" setup>
import { computed, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useRbacStore } from '@/plugins/base/rbac_page/DefaultRbacPagePlugin'

const router = useRouter()
const route = useRoute()

const rbacStore = useRbacStore()

const tabsList = computed(() => {
  return rbacStore.tabsList
})
const routePath = computed(() => {
  if (route.meta?.linkToFullPath == true) {
    if (!route.query || Object.keys(route.query).length === 0) {
      return route.fullPath
    }
    const query = Object.keys(route.query).map(key => `${key}=${route.query[key]}`).join('&')
    const path = `${route.path}${query ? '?' : ''}${query}${route.hash || ''}`
    return path
  }
  return route.path
})
const pathMap: any = computed(() => {
  const state = rbacStore.menus
  const pathMap = state.pathMap
  return pathMap
})

const handleTab = (tabPath: string) => {
  if (tabPath) {
    const tabs = tabsList.value
    let path = pathMap.value[tabPath]
    if (!path) {
      if (!route.meta?.title) return
      path = {
        linkTo: route.meta?.linkToFullPath == true ? route.fullPath || tabPath : tabPath,
        key: route.matched[1]?.path || tabPath,
        name: route.meta?.title || route.matched[1]?.name || '未找到当前路由',
      }
      const index = tabs.findIndex((tab: any) => tab.key === path.key)
      if (index !== -1) {
        rbacStore.tabsList = [
          ...tabs.slice(0, index),
          ...tabs.slice(index + 1),
          path
        ]
      }
    }
    rbacStore.activeTab = path.key
    const defaultComponent = route.matched[1]?.components?.default
    if (!defaultComponent) {
      return
    }
    path.componentName = defaultComponent?.name
    if (tabs.every((tab: any) => tab.key !== path.key)) {
      rbacStore.tabsList = [...tabs, path]
    }
  }
}

const callback = (val: string) => {
  // console.log(val)
}
const removeTabsView = (key: string) => {
  const selectTab = pathMap.value[key]
  let newTabList = tabsList.value.filter((tab) => tab.key !== selectTab?.key)
  if (selectTab) {
    let lastIndex = -1
    newTabList.forEach((tab, i) => {
      if (rbacStore.activeTab === tab.linkTo) {
        lastIndex = i
      }
    })
    if (newTabList.length > 0) {
      rbacStore.tabsList = newTabList
      if (lastIndex === -1) {
        lastIndex = newTabList.length - 1
      }
      const lastTab = newTabList[lastIndex]
      router.push(lastTab.linkTo || '')
    }
  } else {
    newTabList = tabsList.value.filter((tab) => tab.linkTo !== key)
    if (newTabList.length > 0) {
      rbacStore.tabsList = newTabList
      let lastTab = newTabList.find((tab) => tab.linkTo === rbacStore.activeTab)
      if (!lastTab) {
        lastTab = newTabList[newTabList.length - 1]
      }
      router.push(lastTab.linkTo || '')
    }
  }
}
const onEdit = (targetKey: string | MouseEvent) => {
  removeTabsView(targetKey as string)
}
const onChange = (key: string) => {
  router.push(key)
}
watch(
  () => route.path,
  (newVal, oldVal) => {
    handleTab(routePath.value)
  }
)
watch(
  () => pathMap.value,
  (newVal, oldVal) => {
    handleTab(routePath.value)
  }
)
</script>

<style scoped lang="less">
.tabs-view {
  width: 100%;
  border: none;
  border-left: 2px solid #edeff0;
  border-right: 2px solid #edeff0;

  :deep(.ant-tabs-nav) {
    line-height: 8px;
    font-size: 10px;
  }

  :deep(.ant-tabs-nav-add) {
    display: none;
  }

  :deep(.ant-tabs-top > .ant-tabs-nav) {
    margin-bottom: 0;
  }

  :deep(.ant-tabs-content-holder) {
    display: none;
  }

  :deep(.ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab) {
    background: white;
    color: #626880;
    font-size: 12px;
    margin: 0;
    border: none;
    border-right: 2px solid #edeff0;
    border-radius: 0;

    .ant-tabs-tab-remove {
      color: gray;
      line-height: 14px;
      width: 14px;
      font-size: 8px;
      border-radius: 50%;
      background: white;
      padding: 0;
    }
  }

  :deep(.ant-tabs-top > .ant-tabs-nav::before) {
    border: none;
  }

  :deep(.ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab-active) {
    background: #3D4455;

    .ant-tabs-tab-btn {
      color: white;
      text-shadow: none;
    }

    .ant-tabs-tab-remove {
      color: gray;
      font-size: 10px;
    }
  }
}
</style>
